import { createContext } from 'react'

export type MfeComponentProps = {
  name: string
  props?: Record<string, unknown>
  packageName?: string
}

export const MfeComponentContext = createContext<MfeComponentProps>(null)
